import DOMPurify from "isomorphic-dompurify";

export const customSanitize = (html: string | Node) => {
  return DOMPurify.sanitize(html, {
    ADD_ATTR: ["target", "rel", "allowfullscreen", "allow"],
    ADD_TAGS: ["iframe"],
  });
};
export const sanitizeTitle = (html: string | Node) => {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [], // No tags allowed
    ALLOWED_ATTR: [], // No attributes allowed
  });
};
